import LoadingButton from "@mui/lab/LoadingButton";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import axios from "axios";
import { useState } from "react";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import { useAppDispatch } from "@wordform/core/hooks/useStore";
import { RootState } from "@wordform/core/store/store";
import paddleSlice from "./paddle.slice";
import { PaddleAvailableAddon, PaddleAPIResponse } from "./paddle.slice";

type Props = {
  plan: PaddleAvailableAddon;
  open: boolean;
  onClose: any;
};

export const ActivatePlanDialog = (props: Props) => {
  const dispatch = useAppDispatch();
  const { open = false, onClose, ...other } = props;
  const [loading, setLoading] = useState<boolean>(false);
  const { apiUrl } = useSelector((state: RootState) => state.home);

  const activatePlan = async (priceId: string, subscriptionId: string) => {
    try {
      setLoading(true);
      const response = await axios.patch(`${apiUrl}/paddle`, {
        priceId,
        subscriptionId,
      });
      const result: PaddleAPIResponse = response.data.result;
      dispatch(paddleSlice.actions.setPaddlePlans(result));
      props.onClose();

      toast.success("Plan change initiated! The update may take up to a minute. You'll receive a confirmation email shortly.", {
        duration: 8000
      });
      
      setLoading(false);

    } catch (e: any) {
      setLoading(false);
      if (e.response?.data?.error?.message) {
        toast.error("Error: " + e.response.data.error.message);
      } else if (e.request) {
        toast.dismiss();
        toast.error("Network error occurred...");
      } else {
        toast.error("Error activating plan...");
      }
    }
  };

  return (
    <Dialog fullWidth maxWidth="sm" onClose={onClose} open={open}>
      <DialogTitle>Confirm Plan Activation</DialogTitle>
      <DialogContent>
        Are you sure you want to activate the <strong>{props.plan.name}</strong> plan?
      </DialogContent>
      <DialogActions>
        <Button color="inherit" onClick={onClose}>
          Cancel
        </Button>
        <LoadingButton loading={loading} onClick={() => activatePlan(props.plan.priceId, props.plan.subscriptionId)} variant="contained">
          Activate Plan
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};